<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/enterprise-branch?type=1">工作部活动</router-link></li>
                <li><router-link :to="parentLink">{{ parentNav }}</router-link></li>
                <li class="currentNode"><a>{{ parentNav }}活动详情</a></li>
            </ul>
            <div class="page-main">
                    <div class="page-main-tp">
                        <div>
                            <div class="dt">
                                <span class="day">{{ publishTime  | traverseDate('day')}}</span>
                                <span class="bias">/</span>
                                <span class="month"><i>{{ publishTime  | traverseDate('month')}}月</i><i></i>{{ publishTime  | traverseDate('year')}}</span>
                            </div>
                            <div class="dd">工作部活动</div>
                        </div>
                        <div class="article-title">
                            <h3>{{ title }}</h3>
                            <p class="subtitle" v-if="subTitle !== '我要报名'">{{ subTitle }}</p>
                            <button @click="sighUp()"  v-if="subTitle === '我要报名'">我要报名</button>
                        </div>
                    </div>
                    <div class="page-main-btm content-detail"  v-html="content"></div>
                        <!-- <p>本次研讨会邀请到了农业农村部、国家信息中心、商务部、平谷农业中关村管委会、山东德州、广西南宁等各级、各地方政府相关领导、国内外行业专家、优秀企业代表、会员单位共计130余人现场出席会议。同时，线上直播吸引观众高达5万余人，各界人士通过本次会议进一步了解到数字乡村的国际国内最新技术与发展。</p>
                        <p>研讨会上，农业农村部市场预警专家委员会秘书长、农业农村部农业信息服务技术重点实验室主任许世卫在致辞中指出，数字乡村建设应该说是全方位的数字乡村发展的整体体系建设，是一种针对更好的解决农业能力、技术应对能力的工作，数字乡村建设适应我们当前的需要。</p> -->
                    
                </div>
            
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail
} from '@services/indexService.js';
import { addBaoming, addContact } from '@/services/indexService';

export default {
    name:"",
    data() {
        return {
            detailId: '',
            page: '',
            publishTime: '',
            title: '',
            subTitle: '',
            content: '',
            parentNav: '',
            parentLink: '',
            type: '',
            eventCompanyId: '',
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
        companyName() {
            return this.$store.state.permission.companyName;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page;
        this.type = this.$route.query.type;
        this.traverseTitle();
        this.getPlolicyDetail(this.detailId);
    },
    methods: {
        traverseTitle() {
            if (this.type === '1'){
                this.parentLink = `/layout/enterprise-branch?type=1&page=${this.page}`;
                this.parentNav = '信息工作部';
            } else if (this.type === '2'){
                this.parentLink = `/layout/enterprise-branch?type=2&page=${this.page}`;
                this.parentNav = '双招双引工作部';
            } else if (this.type === '3') {
                this.parentLink = `/layout/enterprise-branch?type=3&page=${this.page}`;
                this.parentNav = '医药卫生工作部';
            } else {
                this.parentLink = `/layout/enterprise-branch?type=4&page=${this.page}`;
                this.parentNav = '企业工作部';
            }
        },
        getPlolicyDetail(id) {
            let params = {
                id: id
            };
            getPlolicyDetail(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.content = res.Data.Content;
                    this.eventCompanyId = res.Data.CompanyId;
                } else {
                    this.$message.error("活动详情请求失败");
                }
            })
        },
        sighUp() {
            console.log(this.accountId);
            if (!this.accountId) {
                this.$message.warning("您还没有登录，登录后方可报名！");
                return;
            }
            let param = {
                InviteCode: this.detailId,
                InviteCompanyId: this.companyId, // 报名人协会id
                CompanyName: this.companyName,  // 报名人协会id
                AccountId: this.accountId, // 报名人用户id,
                AccountName: this.loginName, // 报名人姓名
            };
            addBaoming(param).then( res => {
                if (res.Code == 1) {
                    this.$message.success(res.Message);
                } else {
                    this.$message.warning(res.Message);
                }
            })
        }
    }
}
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
.article-title button {
    width: 129px;
    height: 30px;
    line-height: 30px;
    background: #116EBA;
    color: #fff;
    text-align: center;
    outline: 0;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    box-sizing: border-box;
    border: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
}
.article-title button:hover {
    background: #005091;
}
</style>